import { createSlice } from '@reduxjs/toolkit';
import { SubscriptionSate } from 'Types';
import reducers from '../subscription/SubscriptionReducer';

export const SubscriptionState: SubscriptionSate = {
	selectedCommunityPartner: null,
	selectedPlan: null,
	selectedPrimaryPlan: null,
	selectedVoucher: null
};

const SubscriptionSlice = createSlice({
	name: 'subscription',
	initialState: SubscriptionState,
	reducers
});

export const {
	setSubscriptionCommunityPartner,
	setSubscriptionPlan,
	resetSubscription
} = SubscriptionSlice.actions;

export default SubscriptionSlice.reducer;
